
const Market = {
  "name": "Market",
  "kind": "OBJECT",
  "fieldBaseTypes": {
    "currencySettings": "MarketCurrencySettings",
    "enabled": "Boolean",
    "id": "ID",
    "name": "String",
    "priceList": "PriceList",
    "primary": "Boolean",
    "regions": "MarketRegionConnection",
    "webPresence": "MarketWebPresence"
  },
  "implementsNode": true
};
export default Market;